import axios from 'axios';
//https://api.appsgsm.com
//const BASE_URL = 'http://localhost:3500';
const BASE_URL = 'https://api.appsgsm.com';
export const prefixAPINomina = '';

export default axios.create({
    baseURL: BASE_URL
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
}); 